


import React from 'react';
import { Card, CardContent, CardMedia, Typography, IconButton, Grid } from '@mui/material';

const CardImage = ({title, image, clickWrapper }) => {

    return (
        <Card onClick={(e) => clickWrapper()} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardMedia
                component="div"
                sx={{
                    // 16:9
                    pt: '76.25%',
                }}
                image={image}
            />
            <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                    {title}
                </Typography>
            </CardContent>
        </Card>

    );
};

export default CardImage;
